import { createContext } from "react";
var DispatchContext = /*#__PURE__*/createContext(function () {
  return null;
});
export default DispatchContext;